/**  Custom components stores services types constant */
import axiosInstance from '../../services/http.api';
import { DEFAULT_ERROR_MSG } from '../../utils/constants';
import { CERTIFICATE_STATUS, CertificateData } from './certificates.types';

export const CertificateService = {
    /**
     * Fetch certificates data
     * @returns 
     */
    fetchCertificates: async (): Promise<CertificateData[]> => {
        try {
            const res = await axiosInstance.get<any>('/v1/OpportunityCertificate');

            if (!res.data.isSuccess) {
                // Throw an error with custom message
                throw new Error(res.data.message || DEFAULT_ERROR_MSG);
            }

            let data = res.data.opportunityCertificates || [];

            const certificates: CertificateData[] = data.map((opportunityCertificates: any) => ({
                id: opportunityCertificates.certificateId,
                accountName: opportunityCertificates.certificate?.account?.name,
                certificateId: opportunityCertificates.certificate?.scsCertificationNumber,
                validTo: opportunityCertificates.certificate?.validThrough,
                status: opportunityCertificates.certificate?.status
            }));

            return certificates;
        } catch (exe) {
          return [];
        }

    }
};